module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('legend', [_vm._v("Grant Schema Access")]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Mode")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeRadio),
      expression: "modeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "optionsRadios1",
      "name": "optionsRadios",
      "type": "radio",
      "value": "migrate"
    },
    domProps: {
      "checked": _vm._q(_vm.modeRadio, "migrate")
    },
    on: {
      "change": function($event) {
        _vm.modeRadio = "migrate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-primary badge-pill"
  }, [_vm._v("Migrate")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeRadio),
      expression: "modeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "optionsRadios2",
      "name": "optionsRadios",
      "type": "radio",
      "value": "generate"
    },
    domProps: {
      "checked": _vm._q(_vm.modeRadio, "generate")
    },
    on: {
      "change": function($event) {
        _vm.modeRadio = "generate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v("Generate SQL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Team")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamUser),
      expression: "teamUser"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "id": "selectTeamName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.teamUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamNames), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Data Source")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSource),
      expression: "dataSource"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dataSources), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.dataSource
      }
    }, [_vm._v("\n                        " + _vm._s(entry.dataSource.heliumDataSourceName) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Schema Name")]), _vm._v(" "), (_vm.modeRadio !== 'migrate') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schemaName),
      expression: "schemaName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.schemaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schemaName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schemaName),
      expression: "schemaName"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.schemaName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.appList), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry.schemaName) + "\n                    ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetData
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Clear selection\n                ")]), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Alter all obects in the schema name for the selected server to be owned by the selected team"
    },
    on: {
      "click": _vm.grantAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Grant Access\n                ")]) : _c('button', {
    staticClass: "btn btn-secondary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Generate the SQL required to migrate the schema to the team"
    },
    on: {
      "click": _vm.generateSql
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Generate SQL\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-hover"
  }, [_vm._m(2), _c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.dataSources), function(entry) {
    return _c('tr', {
      class: entry.response === 'Ping successful' ? '' : 'table-warning'
    }, [_c('td', [_vm._v(_vm._s(entry.heliumDataSourceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.response))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    ref: "resultsRef",
    staticClass: "container-fluid"
  }, [(_vm.response) ? _c('div', {
    staticClass: "card card-block card-outline-primary",
    attrs: {
      "id": "resultsDiv"
    }
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [(_vm.textBlock) ? _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.textBlock),
      expression: "textBlock",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyToClipBtn",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy SQL to your clipboard!"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.modeRadio === 'generate') ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.textBlockScrollToLine,
      "lang": _vm.textBlockLang
    }
  }) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Schema Access")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info pull-right",
    attrs: {
      "id": "schema-access-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Postgres Permissions")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("By default developer's postgres users to not have permissions to view or update the data and schema of a Helium app")]), _vm._v(" "), _c('strong', [_vm._v("Connection Status")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-inverse"
  }, [_c('tr', [_c('th', [_vm._v("Data Source")]), _vm._v(" "), _c('th', [_vm._v("Ping Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Results")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3544c43c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchemaAccess.vue
// module id = 585
// module chunks = 2